<!-- Compiled at 2026-05-13T13:50:05.286Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<ng-container *ngIf="screen.task"
					><h1
						[innerHtml]="screen.task.taskName | escapeHtml: 'none' | replaceNewlines: 'h1'"
					></h1
				></ng-container>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
